"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TaskTypeListPanel = void 0;
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const core_1 = require("@material-ui/core");
const lab_1 = require("@material-ui/lab");
const core_ui_1 = require("@sierralabs/core-ui");
const WorkflowBuilderContext_1 = require("../../WorkflowBuilderContext");
const EditTaskTypeDialog_1 = __importDefault(require("../dialogs/EditTaskTypeDialog"));
const TaskTypeMenuButton_1 = __importDefault(require("./TaskTypeMenuButton"));
const StyledPanel = (0, styled_components_1.default)(core_ui_1.Panel) `
  .add-icon {
    font-size: 18px;
  }
  .tree-label {
    display: flex;
    align-items: center;
  }
  .tree-text {
    flex: 1;
  }
  .flex-end {
    display: flex;
    justify-content: flex-end;
    padding: 0 12px 0 6px;
  }
`;
const TaskTypeListPanel = () => {
    const { taskTypes = [], findTaskTypes } = (0, WorkflowBuilderContext_1.useWorkflowBuilderContext)();
    const [open, setOpen] = (0, react_1.useState)(false);
    const [snackbar, setSnackbar] = (0, react_1.useState)({ open: false, message: '' });
    const [selected, setSelected] = (0, react_1.useState)();
    return (react_1.default.createElement(StyledPanel, { className: 'task-types-list' },
        react_1.default.createElement(core_ui_1.PanelHeader, { accessory: react_1.default.createElement(core_1.IconButton, { size: 'small', title: 'Add Task Type', onClick: () => {
                    setOpen(true);
                    setSelected(undefined);
                } },
                react_1.default.createElement(core_1.Icon, { className: 'add-icon' }, "add")) },
            react_1.default.createElement(core_1.Typography, { variant: 'overline' }, "Task Types")),
        react_1.default.createElement(core_ui_1.PanelContent, null,
            react_1.default.createElement(lab_1.TreeView, { defaultCollapseIcon: react_1.default.createElement(core_1.Icon, null, "arrow_drop_down"), defaultExpandIcon: react_1.default.createElement(core_1.Icon, null, "arrow_right") }, taskTypes.map(taskType => (react_1.default.createElement(lab_1.TreeItem, { key: taskType.id, nodeId: taskType.id.toString(), label: react_1.default.createElement("div", { className: 'tree-label' },
                    react_1.default.createElement("div", { className: 'tree-text', onClick: () => setSelected(taskType) },
                        taskType.label,
                        " (",
                        taskType.prefix,
                        ")"),
                    react_1.default.createElement("div", { className: 'flex-end' },
                        react_1.default.createElement(TaskTypeMenuButton_1.default, { taskType: taskType, onClickUpdate: () => setSelected(taskType), onChange: taskType => {
                                findTaskTypes();
                                setSnackbar({
                                    open: true,
                                    message: `Task type "${taskType.label} (${taskType.prefix})" deleted successfully.`
                                });
                            } }))) }))))),
        react_1.default.createElement(EditTaskTypeDialog_1.default, { open: open || !!selected, taskType: selected, onCancel: () => {
                setOpen(false);
                setSelected(undefined);
            }, onChange: (taskType, created) => {
                findTaskTypes();
                setOpen(false);
                setSelected(undefined);
                setSnackbar({
                    open: true,
                    message: `Task type "${taskType.label} (${taskType.prefix})" ${created ? 'created' : 'updated'} successfully.`
                });
            } }),
        react_1.default.createElement(core_ui_1.AppSnackbar, { severity: 'success', open: snackbar.open, onClose: () => setSnackbar(snackbar => (Object.assign(Object.assign({}, snackbar), { open: false }))) }, snackbar.message)));
};
exports.TaskTypeListPanel = TaskTypeListPanel;
exports.default = exports.TaskTypeListPanel;
//# sourceMappingURL=TaskTypeListPanel.js.map